import { call, put, select } from 'redux-saga/effects';
import { setJourneyOutcomeReported } from '../slices/clientApiJourney';
import { selectPostSubmissionAnswers } from '../../../Helpers/strategyCollection.helpers';
import { postClientApiJourneyOutcome } from './postClientApiJourneyOutcome';

/**
 * Posts a journey outcome for the current submission, at most once per journey.
 *
 * The flag is set only once the POST resolves, so a send that fails leaves the
 * journey free to report later rather than spending its one outcome on a
 * request that never arrived.
 *
 * Errors are left to the caller, so each site keeps its own metric and capture.
 *
 * The post-submission answers are gathered from the store and attached whenever
 * the journey gathered some, so every outcome that has them carries them.
 *
 * @param {object} outcome - `outcome` and `outcomeDetail`, plus any booking details to forward.
 */
export default function* reportJourneyOutcomeOnce(outcome) {
  const isJourneyOutcomeReported = yield select(
    (state) => state.clientApiJourney?.isJourneyOutcomeReported
  );

  if (isJourneyOutcomeReported) return;

  const submissionId = yield select((state) => state.submission?.id);
  const token = yield select((state) => state.submission?.token);

  const answers = yield select(selectPostSubmissionAnswers);

  yield call(postClientApiJourneyOutcome, {
    submissionId,
    token,
    ...outcome,
    ...(Object.keys(answers).length > 0 && { answers }),
  });

  yield put(setJourneyOutcomeReported({ isJourneyOutcomeReported: true }));
}
